'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');
var Theme_index = require('../../Theme/index.js');
require('styled-components');
require('../../Theme/Normalize/index.js');
require('../../colors-b14f6805.js');
require('../../index-33f41a46.js');
require('../../Theme/common/index.js');
require('../../Theme/inputs/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var WarningIcon = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ width: "28", height: "28", viewBox: "0 0 28 28", fill: "currentColor" }, props),
    React__default['default'].createElement("path", { d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z", fill: Theme_index.theme.colors.iconWarning }),
    React__default['default'].createElement("path", { d: "M13.992 9.91667C14.4897 9.91667 14.875 9.51894 14.875 9.05758C14.875 8.54849 14.4897 8.16667 13.992 8.16667C13.5103 8.16667 13.125 8.54849 13.125 9.05758C13.125 9.51894 13.5103 9.91667 13.992 9.91667ZM13.4168 20.6407V12.317C13.4168 12.1377 13.5801 11.9583 13.7761 11.9583H14.2299C14.4096 11.9583 14.5858 12.1377 14.5858 12.317V20.6407C14.5858 20.8364 14.4096 20.9994 14.2299 20.9994H13.7761C13.5801 20.9994 13.4168 20.8364 13.4168 20.6407Z", fill: Theme_index.theme.colors.white }))); };

exports.default = WarningIcon;
//# sourceMappingURL=index.js.map
